module.exports = __webpack_public_path__ + "img/about_join_title.c17c362e.png";